/**
 * @GOTCHA Switching from regular browser to touch simulation on browser?
 *   Things won't work as expected because this constant doesn't update.
 *
 *   You should refresh when switching between touch and non-touch.
 */
export const IS_TOUCH_DEVICE = ('ontouchstart' in window)
  || (navigator.maxTouchPoints > 0)
  || ((navigator as any).msMaxTouchPoints > 0)
